import { createSlice } from "@reduxjs/toolkit";
import { postTransactionDetails } from "../actions/stripePayment.actions";

const initialState = {
  isLoading: false,
  data: null,
};

const postUserTransactionDataSlice = createSlice({
  name: "Get Client Secret Key for Stripe Payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postTransactionDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(postTransactionDetails.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(postTransactionDetails.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default postUserTransactionDataSlice.reducer;
